module.exports = __webpack_public_path__ + "static/fabric-datepicker-disabled-10d963dfc57ab27f0b7e3456dc8eae4e.png";